import { cloneDeep } from "lodash";
import {
  CREATE_CALENDAR_SUCCESS,
  CREATE_RSVP_SUCCESS,
  DELETE_CALENDAR_SUCCESS,
  EVENT_ACTION_SUCCESS,
  GET_CALENDAR_EVENT_RESOURCE_SUCCESS,
  GET_CALENDAR_EVENT_SUCCESS,
  GET_CALENDAR_SUCCESS,
  GET_RSVP_BY_CALENDAR_ID_SUCCESS,
  GET_RSVP_BY_CALENDAR_SUCCESS,
  GET_RSVP_SUCCESS,
  RESET_CALENDAR_DATA,
  RESET_CALENDAR_DATA_UPDATE,
  SAVE_CALENDAR_DATA_ERROR,
  SAVE_CALENDAR_DATA_SUCCESS,
  UPDATE_CALENDAR_DATA_ERROR,
  UPDATE_CALENDAR_DATA_SUCCESS,
  UPDATE_CALENDAR_EVENT_SUCCESS,
  UPDATE_CALENDAR_RSVP_EVENT_SUCCESS,
} from "../constants";

export const initialState = {
  eventDetails: undefined,
  getEventDeatils: undefined,
  updateEventDeatils: undefined,
  eventList: [],
  is_event_added: false,
  eventResources: undefined,
  rsvpData: undefined,
  getRsvpDataByCalendarId: undefined,
  calendarEventData: null,
  calendarEventDataUpdate: null,
  eventActionDetails: null,
  rsvpCalendar: undefined,
};

export const CalendarEventReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_CALENDAR_SUCCESS: {
      return {
        ...state,
        eventDetails: action.payload,
        is_event_added: true,
      };
    }
    case DELETE_CALENDAR_SUCCESS: {
      // const tempUserActionDetails = cloneDeep(state.userActionDetails);
      // remove(tempUserActionDetails.data, (obj) => obj._id === action.payload);
      return {
        ...state,
        // eventActionDetails: tempUserActionDetails,
        eventList: state.eventList.filter(event => event._id !== action.payload),
        eventActionDetails: action.payload,
      };
    }

    case GET_CALENDAR_SUCCESS: {
      return {
        ...state,
        eventList: action.payload,
        is_event_added: false,
      };
    }

    case GET_CALENDAR_EVENT_SUCCESS: {
      return {
        ...state,
        getEventDeatils: action.payload,
        is_event_added: false,
      };
    }

    case UPDATE_CALENDAR_EVENT_SUCCESS: {
      return {
        ...state,
        updateEventDeatils: action.payload,
        is_event_added: true,
      };
    }

    case GET_CALENDAR_EVENT_RESOURCE_SUCCESS: {
      return {
        ...state,
        eventResources: action.payload,
        is_event_added: true,
      };
    }

    case CREATE_RSVP_SUCCESS: {
      return {
        ...state,
        getRsvpDataByCalendarId: action.payload,
        is_event_added: false,
      };
    }
    case GET_RSVP_BY_CALENDAR_SUCCESS: {
      return {
        ...state,
        getRsvpDataByCalendarId: action.payload,
      };
    }
    case SAVE_CALENDAR_DATA_SUCCESS: {
      return {
        ...state,
        calendarEventData: action.payload,
      };
    }
    case SAVE_CALENDAR_DATA_ERROR: {
      return {
        ...state,
        calendarEventData: "",
      };
    }
    case RESET_CALENDAR_DATA: {
      return {
        ...state,
        calendarEventData: "",
      };
    }

    case UPDATE_CALENDAR_DATA_SUCCESS: {
      return {
        ...state,
        calendarEventDataUpdate: action.payload,
      };
    }
    case UPDATE_CALENDAR_DATA_ERROR: {
      return {
        ...state,
        calendarEventDataUpdate: "",
      };
    }
    case RESET_CALENDAR_DATA_UPDATE: {
      return {
        ...state,
        calendarEventDataUpdate: "",
      };
    }

    case GET_RSVP_SUCCESS: {
      return {
        ...state,
        rsvpData: action.payload,
        // is_event_added: true
      };
    }
    case UPDATE_CALENDAR_RSVP_EVENT_SUCCESS: {
      return {
        ...state,
        rsvpData: action.payload,
        // is_event_added: true,
      };
    }

    case EVENT_ACTION_SUCCESS:
      const tempUserActionDetails = cloneDeep(state.userActionDetails);
      tempUserActionDetails.data.splice(0, 0, action.payload);
      return {
        ...state,
        eventActionDetails: tempUserActionDetails,
        displayUserDetailsError: "",
        // is_event_added:true
      };
    case GET_RSVP_BY_CALENDAR_ID_SUCCESS: {
      return {
        ...state,
        rsvpCalendar: action.payload,
        // is_event_added: true
      };
    }
    default:
      return state;
  }
};
